import { fn } from '@common/utils';
import { KWFApplicationService } from '../KWFApplication';
import { AppVersion } from '@common/interfaces';
import { IKWFRoute } from '../KWFMain';

/* Version Check Controller */
export class CheckVersionController {
    static readonly Template = require('./checkversion.html');
    static readonly Route: IKWFRoute = {
        DescriptionFormula: "'Versionsinformationen'",
        controller: CheckVersionController,
        controllerAs: "Info",
        template: CheckVersionController.Template,
        name: "Versionsinformationen"
    };
    static $inject = ["$scope", "KWFApplication", "InfomaAppVersion"];
    constructor($scope: ng.IScope, private KWFApplication: KWFApplicationService, appVersion: AppVersion) {
        this.Client = $scope["ClientVersionInfo"] = {
            Version: appVersion.Version,
            PatchLevel: appVersion.PatchLevel
        };

        this.RefreshServerVersion();
    }

    RefreshServerVersion() {
        var server = this.Server;
        server.Error = "";
        server.Version = "...";
        server.PatchLevel = "...";
        this.IsInRefresh = true;
        const afterGetServerInfo = () => {
            this.IsInRefresh = false;
            this.ClientIsUptoDate = this.Server.Version == this.Client.Version && this.Server.PatchLevel == this.Client.PatchLevel;
        };
        return this.KWFApplication.GetServerVersionInfo(true).then((info) => {
            $.extend(this.Server, info);
            server.Loaded = true;
        }, err => {
            server.Error = fn.resolveToError(err);
        }).then(afterGetServerInfo, afterGetServerInfo);
    }
    public Server: Partial<AppVersion> & {  Loaded: boolean, Error: string}  = {
        Version: "...",
        PatchLevel: "...",
        Error: "",
        Loaded: false
    };

    public ReloadFromVersion() {
        window.location.reload();
    }

    public Client: AppVersion;

    public ClientIsUptoDate: boolean;

    public IsInRefresh: boolean;
}
